import React from "react";
import { dateToLocalConverter } from "../../../utilities/functions";
const PublishDateCell = ({ publishDate }) => {
  return <div>{publishDate ? dateToLocalConverter(publishDate) : ""}</div>;
};

export default PublishDateCell;
